export const environment = {
  production: true,
  name: 'dev',
  'truckvalApiUrl': 'https://truckval.api-dev.env.datiuminsights.com.au/',
  'portalUrl': 'https://portal-dev.env.datiuminsights.com.au',
  'bikevalUrl': 'https://bikeval-dev.env.datiuminsights.com.au/',
  'carvalUrl': 'https://instantval-dev.env.datiuminsights.com.au/',
  'salvagevalUrl': 'https://salvageval-dev.env.datiuminsights.com.au/',
  'pricemytruckUrl': 'https://pricemytruck-dev.env.datiuminsights.com.au/',
  'autopredictUrl': 'https://autopredict-dev.env.datiuminsights.com.au/',
  'assessvalUrl': 'https://assessval-dev.env.datiuminsights.com.au/',
  'bikevalApiUrl': 'https://bikeval.api-dev.env.datiuminsights.com.au/',
  'bikevalWebportalApiUrl': 'https://autopredict.api-dev.env.datiuminsights.com.au/autp/api/',
  'truckvalUrl': 'https://truckval-dev.env.datiuminsights.com.au/',
  'priceMyTruckUrl': 'https://pricemytruck-dev.env.datiuminsights.com.au/',
  'portalApiUrl': 'https://autopredict.api-dev.env.datiuminsights.com.au/autp/api/',//'https://api-dev.env.autopredict.pvsdf.com.au/autp/api/',
  'pppApiUrl': 'https://api-dev.env.pricespeoplepay.com.au/1.0/api/',
  'pppValuationMicorAppApiUrl': 'https://api-dev.env.datiuminsights.com.au/iv/api/',
  'ppp-adminFrontEndUrl': 'https://web-dev.env.pricespeoplepay.com.au/',
  'ppp-adminMicroAppToken': '3C1232F6-31D4-42CF-81EA-8CD4DCC0AE25',
  'ppp-adminStsServer': 'https://apmf.dev2.pickles.com.au/.well-known/openid-configuration',
  'ppp-adminClientId': 'PicklesOidcCompatiblePPP',
  'ppp-adminPayPal': 'ASbaUqw197aWiW_Mcb462BF9qo1B7UH62UHhYR8iTmU8RuCMw0LjkBy2UbTeVxZWLiT9N9_d87M_rrXX',
  'ppp-adminGCaptchaKey': '6LdAMbAbAAAAAOPO2Q2vaJqCi7Tlc1G4y9qeGqf2',
  'pppAdminApiUrl': 'https://api-dev.env.pricespeoplepay.com.au/1.0/api/',
  'apiUrl': 'https://autopredict.api-dev.env.datiuminsights.com.au/autp/api/',
  'frontEndUrl': 'https://autopredict-dev.env.datiuminsights.com.au',
  'instantvalUrl': 'https://instantval-dev.env.datiuminsights.com.au/',
  'script': 'true',
};
